import {MappedDataItem} from './MappedDataItem';
import {MappedFromData} from './MappedFromData';
import {ReportDataService} from '../../report-data.service';

import {DropEvent} from 'ng-drag-drop';

export class MappableData {

  label = '';
  mappedData = new Array<MappedDataItem>();
  isFullyMapped = false;
  mappedCount = 0;

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, label: string) {
    this.reportService = reportService;
    this.label = label;
  }

  onMap(e: DropEvent, target) {
    target.mappedFromData = new MappedFromData(e.dragData.fileName, e.dragData.name, e.dragData.index);
    target.class = 'mapped';
    this.reportService.mapData(target);
  }

  getItemCount() {
    return this.mappedData.length;
  }

  getLabel() {
    return this.label;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/data/MappableData.ts